import React from "react";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import CheckBox from "../../../PageLayout/CheckBox";
import {toggleArrayObject} from "../../../FeatureCreator/FeaturesFilters/filtersFunctions";

const WizardPopupInputsGroup = (props) => {

  const {inputObject, inputObjectIndex} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {inputFields} = wizardPopupState;

  const changeInputValue = (value) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        inputFields: inputFields.map(inputObj => {
          if (inputObj.id === inputObject.id) {
            inputObj[value] = !inputObject[value];
          }
          return inputObj
        })
      }
    })
  }

  return (
    <li className="wizard-popup__drag" key={inputObject.id} data-index={inputObjectIndex}>
      <span className="wizard-popup__drag-name generic-popup-title flex-item--50">{inputObject.id}</span>
      <div className="ui-svg-checkbox">
        <CheckBox type={"tiny"}
                  checked={inputObject.checked}
          // text={intl.formatMessage({id: "wizard.popup.inputFields." + inputProp})}
                  text={"Enabled"}
                  onChecked={() => changeInputValue("checked")} />
      </div>
      <div className="ui-svg-checkbox">
        <CheckBox type={"tiny"}
                  checked={inputObject.required}
                  text={"Required"}
                  onChecked={() => changeInputValue("required")} />
      </div>
      <div className="ui-svg-checkbox">
        <CheckBox type={"tiny"}
                  checked={inputObject.oneLine}
                  text={"One Line"}
                  onChecked={() => changeInputValue("oneLine")} />
      </div>
    </li>
  )
};

export default WizardPopupInputsGroup
